export default "__VITE_ASSET__gurMrUVg__"